// 'use strict'

const dictlist = {}

import m from 'mithril'
var util = require('../helpers/util')
// var xmlToJSON = require('xmlToJSON')
// var config = require('../helpers/env.json')[process.env.NODE_ENV || 'development']
require('polythene/theme/theme')
var btn = require('polythene/button/button')

dictlist.Dict = function(data) {
    var id = m.prop(data.id)
    var name = m.prop([])
    data.name.forEach(function(item) {
        name().push({
            name: item.text,
            lang: item.lang
        })
    })
    var hits = m.prop(0)

    return {id: id, name: name, hits: hits}
}


dictlist.DictMeta = function(data) {
    var meta = data.dictionary.meta || {}
    this.name = m.prop(meta._attr.name._value)
    // this.license = m.prop(meta._attr.license._value)
    this.desc = m.prop(meta.description.p._text)
    this.srclng = m.prop(meta.langs.srclang)
    this.trglng = m.prop(meta.langs.trglang)
}

// dictlist.DictMeta.get = function(id) {
//     return m.request({
//         method: 'GET',
//         url: config.EXIST_URL + "/dictionary/" + id,
//         type: dictlist.DictMeta,
//         deserialize: function(xml) {
//             var myOptions = {
//                 childrenAsArray: false
//             }

//             return xmlToJSON.parseString(xml, myOptions)
//         }
//     })
// }

var dict = {
  view : function(args, dict) {
    return m.component(btn, {
      tag : "button",
      class : "dropdown-item",
      label : dict.name().find(item => item.lang == mx.translate.use())
              .name + " (" + dict.hits() + ")",
      raised : true,
      events : {
        onclick : args.binds.bind(this, dict)
      }
    })
  }
}

const dropdown = (ctrl, args) => {
  return m(".dropdown-container",
    m.component(btn, {
      label : args.binds().name().find(item => item.lang == mx.translate.use())
              .name,
      raised : true,
      tag : "button",
      borders : true,
      class : "dropdown-btn",
      events : {
        onclick : () => ctrl.open() ? ctrl.open(false) : ctrl.open(true)
      }
    }),
    m("#dicts", {
      class: "dropdown-content",
      style : {
        display : ctrl.open() ? 'block' : 'none'
      }
    }, [
      args.items()
        .filter(dict => dict.id().indexOf(args.binds().id()) != 0)
        .map(dict.view.curry(args))
    ])
  )
}

dictlist.vm = (function() {
    var vm = {}
    // open is a prop(Boolean) that determines if the dropdown is open or not
    // vm.open = m.prop(false)

    return vm
})()

dictlist.controller = function() {
    this.open = m.prop(false)
}

dictlist.view = function(ctrl, args) {
	return m(".col-md-4.col-xs-12", [
        dropdown(ctrl,args)
    ])
}

export default dictlist
